/**
 * @desc 财务画像-基础信息-行业分析
 */
import style from './nalysis.scss';
import React, { PureComponent } from 'react';
import BBDLineBar from '../../../common/echarts/BBDLineBar';
import BBDMapChinaDataRange from '../../../common/echarts/BBDMapChinaDataRange';
import GroupBox from '../../../common/groupBox/GroupBox';
import Pagination from '../../../common/pagination/Pagination';
import NoData from '../../../common/noData/NoData';
import FormSearch from '../common/FormSearch';
import { IndustryTableTitle } from '../common/columns';
import { numberFixed } from '../../../../utils/formatter';
import { queryCompanyInfo } from '../../../../services/financialPicture/common';
import { paramFilter, isNotEmpty, isEmpty } from '../../../../utils/util';
import { Col, Row, Table, Spin } from 'antd';
import {
    companyIndustrygeo,
    assetIndustrygeo,
    financialAbstract,
    financialInfo
} from '../../../../services/financialPicture/baseInfo';
import { commonRequest, formatMapOption, commonLineOptin } from '../../common/commons';

export default class IndustryAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.mapEvents = { click: this.onMapSelect };
        this.state = {
            mapOption: {},
            assetOption: {},
            profitOption: {},
            mapLoading: true,
            assetLoading: true,
            tabelLoading: true,
            selectedProvince: '',
            companyData: {},
            total: 0,
            pageSize: 10,
            pageNum: 1,
            order: 1,
            tabelData: [],
            tabelInfoData: []
        };
    }

    componentDidMount() {
        this.mapIndustry();
        this.totalAsset();
        this.financialAbstractProt();
        this.financialInfoProt();
        this.publicCompany();
    }

    // 获取公司行业信息
    publicCompany = () => {
        queryCompanyInfo(commonRequest()).then((res = {}) => {
            this.setState({
                companyData: res
            });
        });
    };

    // 获取地图数据
    mapIndustry = () => {
        this.setState({
            mapLoading: true
        });
        companyIndustrygeo(commonRequest()).then(data => {
            data = data || [];
            this.setState({
                mapLoading: false,
                mapOption: formatMapOption(data)
            });
        }).catch(() => {
            this.setState({
                mapLoading: false,
                mapOption: {}
            });
        });
    };

    // 根据省份获取区域信息
    onMapSelect = (e) => {
        let { mapOption } = this.state, selectedProvince = '';
        if (!e.data || !e.data.provincename) { // 不合理的区域和没有数据的区域
            return;
        }
        selectedProvince = e.data.selected ? {} : e.data;
        mapOption.series[0].data.forEach(d => {
            d.selected = d.name === selectedProvince.name;
        });
        mapOption.notMerge = false;
        this.setState({ selectedProvince, mapOption: { ...mapOption }  }, () => {
            delete mapOption.notMerge;
            this.totalAsset();
        });
    };

    // 获取折线图数据
    totalAsset = () => {
        this.setState({
            assetLoading: true
        });
        assetIndustrygeo(commonRequest(paramFilter({ provinceCode: this.state.selectedProvince.provinceCode }))).then(data => {
            data = data || {};
            this.setState({
                assetLoading: false,
                assetOption: this.formatAssetOption(data.totasset, data.reportyear),
                profitOption: this.formatAssetOption(data.netprofit, data.reportyear)
            });
        }).catch(() => {
            this.setState({
                assetLoading: false
            });
        });
    };

    formatAssetOption = (totasset, reportyear) => {
        let data = [], color = ['#534FCF'];
        totasset.map(d => {
            data.push(numberFixed(d));
        });
        return commonLineOptin({ lineData: data, category: reportyear, color: color, same: true });
    };

    // 财务摘要
    financialAbstractProt = () => {
        const { pageNum, pageSize } = this.state;
        this.setState({
            tabelLoading: true
        });
        financialAbstract(commonRequest({ pageNum: pageNum, pageSize: pageSize })).then(data => {
            data = data || [];
            this.setState({
                tabelLoading: false,
                tabelData: data.list || [],
                total: data.total || 0
            });
        }).catch(() => {
            this.setState({
                tabelLoading: false,
                tabelData: []
            });
        });
    };

    pageChange = (pageNum, pageSize) => {
        this.setState({ pageNum, pageSize }, () => {
            this.financialAbstractProt();
        });
    };

    reportDataSource = () => {
        const { pageNum, pageSize } = this.state;
        return [
            {
                title: '序号',
                dataIndex: '',
                width: 90,
                render: (v, d, i) => (pageNum - 1) * pageSize + i + 1
            },
            ...IndustryTableTitle
        ];
    };

    // 财务摘要详情
    financialInfoProt = () => {
        financialInfo(commonRequest()).then(data => {
            data = data || [];
            this.setState({
                tabelInfoData: this.dataList(data || {}) || []
            });
        }).catch(() => {
            this.setState({
                tabelInfoData: []
            });
        });
    };

    dataList = (data) => {
        let allData = [], maxTwenty = {}, medianTwenty = {}, minTwenty = {},
            twenty = {
                a20: '', bizinco: '', bizincozzl: '',
                grossrate: '', marketval: '', netprofit: '',
                npcut: '', sesname: '', symbol: ''
            };
        for (let d in twenty) {
            twenty[d] = data[d];
            maxTwenty[d] = data['max' + d];
            medianTwenty[d] = data['median' + d];
            minTwenty[d] = data['min' + d];
        }

        twenty['nameIn'] = '目标公司';
        maxTwenty['sesname'] = '最高值';
        medianTwenty['sesname'] = '中位值';
        minTwenty['sesname'] = '最低值';
        allData.push(twenty, maxTwenty, medianTwenty, minTwenty);
        return allData;
    };

    // 同行业公司财务摘要详情
    reportDataInfo = () => {
        return [
            {
                title: '序号',
                dataIndex: 'nameIn',
                width: 90
            },
            ...IndustryTableTitle
        ];
    };

    render() {
        const {
            mapOption, mapLoading, assetLoading, assetOption,
            profitOption, tabelLoading, tabelInfoData, tabelData,
            total, pageNum, pageSize, selectedProvince, companyData
        } = this.state;
        let provinceName = selectedProvince.name || '';
        return (
            <GroupBox title="公司行业信息" id="company-industry">
                <Row>
                    <Col span={14}>
                        <div className={style.industryMap}>
                            <p className="sub-title">行业公司地理分布</p>
                            <div className={style.mapEchart}>
                                {mapLoading ? <Spin /> :
                                    isNotEmpty(mapOption) ?
                                        <BBDMapChinaDataRange option={mapOption} onEvents={this.mapEvents} /> :
                                        <NoData />
                                }
                            </div>
                        </div>
                    </Col>
                    <Col span={10}>
                        <div className={style.publicLin}>
                            <div className={style.industryLineBox}>
                                <p className="sub-title">{provinceName}{companyData.csrclevel1NAME}总资产</p>
                                <div className={style.industryLine}>
                                    {assetLoading ? <Spin /> :
                                        isNotEmpty(assetOption) ?
                                            <BBDLineBar option={assetOption} /> :
                                            <NoData />
                                    }
                                </div>
                            </div>
                            <div className={style.industryLineBox}>
                                <p className="sub-title">{provinceName}{companyData.csrclevel1NAME}总利润</p>
                                <div className={style.industryLine}>
                                    {assetLoading ? <Spin /> :
                                        isNotEmpty(profitOption) ?
                                            <BBDLineBar option={profitOption} /> :
                                            <NoData />
                                    }
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="sub-title">同行业公司财务摘要</div>
                        <div>
                            {
                                isEmpty(tabelInfoData) ? null :
                                    <Table
                                        className="industry"
                                        rowKey="sesname"
                                        pagination={false}
                                        bordered
                                        dataSource={tabelInfoData}
                                        columns={this.reportDataInfo()}
                                    />
                            }
                            <Table
                                showHeader={isEmpty(tabelInfoData)}
                                rowKey="symbol"
                                loading={tabelLoading}
                                pagination={false}
                                bordered
                                dataSource={tabelData}
                                columns={this.reportDataSource()}
                                footer={() => total > 10 ? <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange} /> : null}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="margin-top-20">
                            <div className="sub-title">公司趋势对比</div>
                            <FormSearch companyData={companyData} />
                        </div>
                    </Col>
                </Row>
            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/IndustryAnalysis.jsx